import { formatMoney } from "../../lib/currency";

function PaymentStatus({ s }) {
  const map = {
    paid:    "bg-emerald-500/10 text-emerald-300 border-emerald-500/40",
    pending: "bg-amber-500/10 text-amber-300 border-amber-500/40",
    unpaid:  "bg-red-500/10 text-red-300 border-red-500/40",
    expired: "bg-slate-500/10 text-slate-300 border-slate-500/40",
  };
  return <span className={`text-[10px] label-tech px-2 py-1 rounded border ${map[s] || map.pending}`}>{s}</span>;
}

export default function AdminTransactionsTab({ txns, t }) {
  return (
    <div className="tech-card overflow-hidden" data-testid="admin-txns">
      {txns.length === 0 ? <div className="p-8 text-center text-slate-500 text-sm">{t("admin.noTxns")}</div> : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-800 text-slate-500 text-xs">
              <th className="text-left px-4 py-2 label-tech">{t("admin.thDate")}</th>
              <th className="text-left px-4 py-2 label-tech">{t("admin.thUser")}</th>
              <th className="text-left px-4 py-2 label-tech">{t("admin.thAmount")}</th>
              <th className="text-left px-4 py-2 label-tech">{t("admin.thStatus")}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {txns.map((tx) => (
              <tr key={tx.session_id} data-testid={`admin-txn-${tx.session_id}`}>
                <td className="px-4 py-3 text-xs text-slate-400 font-mono-data">{new Date(tx.created_at).toLocaleString()}</td>
                <td className="px-4 py-3 text-xs text-slate-300">{tx.email}</td>
                <td className="px-4 py-3 font-mono-data text-blue-400">{formatMoney(tx.amount, tx.currency?.toUpperCase() || "EUR")}</td>
                <td className="px-4 py-3"><PaymentStatus s={tx.payment_status}/></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
